<template>
  <div class="bg-light-gray px-4 mb-2">
    <div class="row">
      <div class="col-12 mb-3 ">
        <icon-view
          :has-border="false"
          icon="fas fa-file-upload text-orange"
          icon-size="17px"
          title="Digitalización del Expediente Único"
          variant="custom-icon-view"
          icon-background="white"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md-4 mb-2">
          <div class="data-label mb-2">
            Archivo:
          </div>
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            mode="eager"
          >
            <div class="row">
              <div
                v-if="referralDocument?.documentId != null"
                class="col-sm d-flex "
              >
                <span class="file-name text-underline">
                  {{ referralDocument?.filename }}
                </span>
              </div>
              <div class="col-sm d-flex">
                <custom-file-input
                  ref="file"
                  v-model="referralDocument"
                  :accept="'.pdf'"
                  :attachment-id="referralDocument?.documentId"
                  display-style="normal"
                  :on-download="downloadFile"
                  :error="errors[0]"
                />
              </div>
            </div>
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="saveReferralDocument()"
      />
    </div>
  </div>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import { serialize as objectToFormData } from 'object-to-formdata';
import documentsService from '@/services/api/document.api';

export default {
  name: 'UploadSingleFile',
  components: {
    CustomFileInput,
    ActionButton,
    IconView,
  },
  mixins: [alertMixin],
  props: {
    peiAtServiceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      referralDocument: null,
    };
  },
  async mounted() {
    await this.getReferralDocument();
  },
  methods: {
    async downloadFile() {
      await documentsService.downloadFromServer(
        this.referralDocument.documentId
      );
    },
    async getReferralDocument() {
      var { data } = await referralAndEquipmentsservice.getReferralDocument(
        this.peiAtServiceId,
        codeDocumentTypes.SingleFileDigitization
      );
      this.referralDocument = data;
    },
    async saveReferralDocument() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea seguir con la actualización del expediente?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }
      const formData = objectToFormData(
        { file: this.referralDocument },
        {
          indices: true,
        }
      );
      referralAndEquipmentsservice
        .saveReferralDocument(
          this.peiAtServiceId,
          codeDocumentTypes.SingleFileDigitization,
          formData
        )
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        })
        .then(() => {
          this.ShowToast(
            'Éxito',
            'El documento ha sido cargado exitosamente.',
            'success'
          );
          this.$emit('cancel');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
